import React from "react";
import { getHotelStatus } from "../../../../../utils/statusUtils";
import { convertFromRaw, EditorState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';

const NotesTable = ({shift}: any) => {
    const renderSavedContent = () => {
        try {
            const contentState = convertFromRaw(JSON.parse(shift.notesJson));
            const editorState = EditorState.createWithContent(contentState);
    
            const customStyleMap = {
                inlineStyles: {
                    HIGHLIGHT: {
                        style: { backgroundColor: 'yellow' }
                    }
                }
            };

            let html = stateToHTML(editorState.getCurrentContent(), customStyleMap);
            html = html.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');

            return <div dangerouslySetInnerHTML={{ __html: html }} />;
        } catch (error) {
            return <div></div>;
        }
    };

    return (
        <>
            {shift.hotelStatus === 0 ?
                <div className="notes-table">
                    <div className="notes-header notes-bg">
                        <div className="center-text font-600">PERSONAL NOTES SECTION (PACE ONLY, DON'T SEND)</div>
                    </div>
                    <div className="notes-data">
                        {renderSavedContent()}
                    </div>
                </div> :
                <div className="notes-hotel-table">
                    <div className="notes-header notes-bg">
                        <div className="center-text font-600">PERSONAL NOTES SECTION (PACE ONLY, DON'T SEND)</div>
                    </div>
                    <div className="notes-header hotes-bg">
                        <div className="center-text font-600">HOTELS</div>
                    </div>
                    <div className="notes-data">
                        {renderSavedContent()}
                    </div>
                    <div className="notes-data center-text flex-direction-column" style={{fontWeight: 500}}>
                        {getHotelStatus(shift.hotelStatus)}
                    </div>
                </div>
            }
        </>
    )
}

export default NotesTable;
